export default class NoTiles {
  constructor() {
    this.name = 'noTiles'
    this.alt = 'noTiles'
    this.tileSize = new google.maps.Size(256, 256)
    this.maxZoom = 26
  }

  getTile() {
    return document.createElement('div')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/map/NoTiles.js